import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CreateCallResponse, CreateLinkMeetingResponse, CreateMeetingResponse, GetMeetingInfoResponse, JoinMeetingResponse } from '../types/meeting-management';

@Injectable({
  providedIn: 'root'
})
export class MeetingManagementService {
  constructor(private apiService: ApiService) {
  }

  createMeeting = (body: { meetingName: string, meetingId: string, adminIds: string[], userIds: string[], groupIds: string[], hostInfo: { name: string, userId: string } }) => {
    return this.apiService.post<CreateMeetingResponse>("/meeting/zego-cloud-meeting/create-meeting", body, {});
  }

  createLinkMeeting = (isPublic: number) => {
    // TODO(ducvm18): Remove this
    if (localStorage.getItem('meeting_public_override') === '1') {
      isPublic = 1;
    }

    return this.apiService.post<CreateLinkMeetingResponse>("/meeting/zego-cloud-meeting/create-link-meeting", { isPublic, isWeb: true }, {});
  }

  joinMeeting = (userId: string, meetingId: string) => {
    return this.apiService.post<JoinMeetingResponse>("/meeting/zego-cloud-meeting/join-meeting", { userId, meetingId }, {});
  }


  getMeetingInfo = (meetingId: string) => {
    return this.apiService.post<GetMeetingInfoResponse>("/meeting/zego-cloud-meeting/get-meeting-info", { meetingId }, {});
  }

  createCall = (body: { isVideo : boolean, roomId : string, calleeId : string[], callerId : string }) => {
    return this.apiService.post<CreateCallResponse>("/meeting/zego-call-bubble/create-call", body, {});
  }
}
